import split from '@os/split-point';

const WeatherSVGIcon = split( () => import( /* webpackChunkName: "weather-svg-icon" */ './weather-svg-icon') );
export default WeatherSVGIcon;
